<template>
  <div class="courseListPage" :class="[_isMobile() ? 'courseListMobilePage' : '']">
    <ul class="classBox">
      <li class="classList" v-for="list,index in searchList" :key="index">
        <a-row type="flex" justify="start">
            <a-col :xs="24" :sm="24" :md="1">{{list.name}}：</a-col>
            <a-col :xs="24" :sm="24" :md="22">
                <span v-for="item in list.list" :key="item.value" class="tyleList" :class="[queryForm[list.value] ==  item.value ? 'tyleListActive':'']" @click="setSearch(list,item)">{{ item.text }}</span>
            </a-col>
        </a-row>
      </li>
    </ul>
    <ul class="classBox">
      <li class="classList">
        <a-row type="flex" justify="start">
            <a-col :xs="24" :sm="24" :md="1">排序：</a-col>
            <a-col :xs="24" :sm="24" :md="6">
                <span class="tyleList tyleListText" :class="[queryForm.column ==  'orderBy' ? 'tyleListTextActive':'']" @click="setSearch({value:'column'},{value:'orderBy'})">最新教程</span>
                <span class="tyleList tyleListText" :class="[queryForm.column ==  'viewNum' ? 'tyleListTextActive':'']" @click="setSearch({value:'column'},{value:'viewNum'})">最多学习</span>
            </a-col>
            <a-col :xs="24" :sm="24" :md="1">难度：</a-col>
            <a-col :xs="24" :sm="24" :md="6">
                <span v-for="item,index in courseLevelList" :class="[queryForm.courseLevel ==  item.value ? 'tyleListTextActive':'']" :key="index" class="tyleList tyleListText" @click="setSearch({value:'courseLevel'},item)">{{ item.text }}</span>
            </a-col>
            <a-col :xs="24" :sm="24" :md="1">类型：</a-col>
            <a-col :xs="24" :sm="24" :md="6">
                <span v-for="item,index in courseType3List" :key="index" :class="[queryForm.courseType3 ==  item.value ? 'tyleListTextActive':'']" class="tyleList tyleListText" @click="setSearch({value:'courseType3'},item)">{{ item.text }}</span>
            </a-col>
        </a-row>
      </li>
    </ul>
    <a-row :gutter="_isMobile() ? [0, 20] : [20, 20]" v-if="courseList.length > 0">
      <a-col :xs="24" :sm="24" :md="6" v-for="(item, index) in courseList" :key="index">
        <div class="courseList" @click="openDetailsFn(item)">
            <div class="courseImage">
              <img :src="item.courseCover_url" class="courseImage" alt="">
                <div class="listType" v-if="item.courseType3" :style="{'background':listTyleColir[Math.floor(Math.random() * listTyleColir.length)]}">{{ item.courseType3_dictText }}</div>
                <div class="listnum">{{item.courseCount || 0}} 课时</div>
            </div>
            <p class="p1">{{ item.courseName || '-'}}</p>
            <p class="p2">{{ item.courseSource || '-'}}</p>
          <div class="courseFooter">
            <div class="courserType">{{  item.teacherName || '-'}}</div>
            <div class="courserOverview">
              <span>{{ item.courseLevel_dictText }}</span>
              <!-- <span v-for="v,i in item.courseType_dictText.split(',')" :key="i"><i v-if="i != 0">|</i> {{ v }}   </span> -->
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
    <a-empty v-else description="暂无课程" style="margin: 60px auto;" />
  </div>
</template>
  <script>
import { mixinDevice } from "@/utils/mixin.js";
import {ajaxGetDictItems,getDictItemsFromCache} from '@/api/api'
import { getAction } from "@/api/manage";
export default {
  mixins: [mixinDevice],
  name: "",
  components: {},
  data() {
    return {
      queryForm:{
        courseType:'',
        courseType2:'',
        suitableAge:'',
        courseLevel:'',
        courseType3:'',
        column:'',
      },
      backgroundList: ["#AE5DA1", "#EC6941", "#32B16C", "#556FB5"],
      listTyleColir:['linear-gradient(90deg, #8FFCA0, #0BCBFB)','linear-gradient(90deg, #C82090, #6A14D1)'],
      classActive: 1,
      courseList:[],
      searchList:[
        {
          code:'course_type',
          value:'courseType',
          name:'主题',
          list:[{text:'全部',value:''}],
        },{
          code:'suitable_age',
          value:'suitableAge',
          name:'学段',
          list:[{text:'全部',value:''}],
        },{
          code:'course_type2',
          value:'courseType2',
          name:'活动',
          list:[{text:'全部',value:''}],
        }
      ],
      courseLevelList:[],
      courseType3List:[]
    };
  },
  created() {
    for(var i=0;i<this.searchList.length;i++){
      this.init(this.searchList[i].code,i)
    }
    this.getData()
    ajaxGetDictItems('courseLevel',null).then(res=>{
      if(res.success){
        this.courseLevelList = res.result
      }
    })
    ajaxGetDictItems('course_type3',null).then(res=>{
      if(res.success){
        this.courseType3List = res.result
      }
    })
  },
  mounted() {},
  methods: {
    init(type,index){
      ajaxGetDictItems(type,null).then(res=>{
        if(res.success){
          this.searchList[index].list = this.searchList[index].list.concat(res.result) 
        }
      })
    },
    setSearch(list,item){
      this.queryForm[list.value] = this.queryForm[list.value] == item.value ? '': item.value
      this.getData()
    },
    getData(){
      getAction('/teaching/teachingCourse/showCourse',this.queryForm).then(res=>{
        if(res.code == 200){
          this.courseList = res.result.records
        }
      })
    },
    openMoreFn() {
      this.$router.push({ path: "/list" });
    },
    openDetailsFn(item){
      this.$router.push({path:'/detail',query:{id:item.id}})
    }
  },
};
</script>
  <style lang='scss' scoped>
  .courseListMobilePage{
    .classBox{
        padding: 10px !important;
    }
    .classList {
        padding: 10px 0 !important;
    }
    .classList:last-child{
        padding: 10px 0 0 0 !important;
    }
  }
.courseListPage {
  width: 100%;
  p {
    margin: 0;
  }
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .courseList:hover {
    box-shadow: 2px 2px 6px 0px rgba(91, 106, 140, 0.36);
  }
  .courseList {
    width: 100%;
    height: auto;
    cursor: pointer;

    background: #ffffff;
    border-radius: 10px;
    border: 1px solid #d2d2d2;
    .courseFooter {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 10px;
      font-size: 16px;
      color: #666666;
    }
    .courseImage {
      width: 100%;
      height: 180px;
      border-radius: 10px 10px 0 0;
      position: relative;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: cover;

      }
      .listType{
        position: absolute;
        top: 10px;
        right: 0;
        z-index: 9;
        line-height: 24px;
        width: auto;
        padding: 0 9px;
        font-size: 14px;
        color: #FFFFFF;
        height: 24px;
        background: linear-gradient(90deg, #8FFCA0, #0BCBFB);
        border-radius: 11px 0px 0px 11px;
      }
      .listnum{
        width: auto;
        padding: 0 9px;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 24px;
        height: 24px;
        background: #00000031;
        border-radius: 12px;
        position: absolute;
        right: 10px;
        bottom: 10px;
        z-index: 9;
      }
    }
    .p1 {
      font-weight: bold;
      font-size: 18px;
      color: #333333;
      padding: 14px 10px 6px 10px;
    }
    .p1:hover {
      color: #184dd5;
    }
    .p2 {
      font-size: 16px;
      color: #666666;
      padding: 0 10px;
    }
  }
  .classBox {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background: #F7F8FA;
    border-radius: 5px;
    border: 1px solid #7D7D7D;
    margin-bottom: 12px;
    .classList {
        font-size: 16px;
        color: #333333;
        padding: 20px 0;
        border-bottom: 1px solid #D2D2D2;
    }
    .classList:last-child{
        border: none;
        padding: 20px 0 0 0;
    }
    .classList:first-child{
        padding-top: 0;
    }
    .tyleList{
        display: inline-block;
        padding: 0 10px;
        margin-right: 15px;
        cursor: pointer;
        border-radius: 5px;
    }
     .tyleList:hover {
      background: #184dd5;
      color: #fff;
      border-color: #184dd5;
    }
    .tyleListActive {
      background: #184dd5 !important;
      color: #fff !important;
      border-color: #184dd5 !important;
    }
    .tyleListText:hover{
        color: #184dd5 !important;
        background: transparent !important;
    }
    .tyleListTextActive{
      color: #184dd5 !important;
      background: transparent !important;
    }
  }
}
</style>
  